import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const isAdminSelector = state => state.libraries.isAdmin

const getDistrictOverlayData = createSelector(
	[isAdminSelector],
	isAdmin => ({
		icon: isAdmin ? localize('district_library_onboarding_overlay_admin_video') : localize('district_library_onboarding_overlay_video'),
	})
)

export default getDistrictOverlayData
